// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { linesHeaderStyles } from "@sc/App/Components/Cart/LinesHeader";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { color, getSystemColor, xScreen } from "@sc/XDL/Utilities";
import { mergeWithCss } from "@sc/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

const headerItemStyles: InjectableCss = {
    css: css`
        font-size: 12px;
        font-weight: bold;
        line-height: 14px;
        padding: 8px 0;
        border-right: 1px solid ${color("common.border")};
    `,
};
linesHeaderStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: 102px 25px 2.1fr 1.2fr 0.9fr 1.3fr 15px;
        grid-column-gap: 13px;

        ${xScreen("lte", "lg")} {
            grid-template-columns: 102px 25px 3fr 1.5fr 0.9fr 1.3fr 15px;
        }

        grid-auto-flow: column;
        padding: 0 12px;
        color: ${color("common.ui7")};
        font-size: 13px;
        line-height: 17px;
        font-weight: ${fontConfig.weight.semiBold};
        width: 100%;
        background: ${color("common.ui2")};
        border: 1px solid ${color("common.border")};
        border-radius: 4px;
        @media print {
            color: ${getSystemColor("common.white")};
            background: ${getSystemColor("primary")};
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
linesHeaderStyles.itemDescription = {
    ...mergeWithCss(headerItemStyles, {
        css: css`
            grid-column: 1 / 4;
            ${xScreen("lte", "md")} {
                grid-column: 1 / 6;
            }
        `,
    }),
};

linesHeaderStyles.priceUnit = {
    ...mergeWithCss(headerItemStyles, {
        css: css`
            grid-column: 4 / 5;
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    }),
};
linesHeaderStyles.qty = {
    ...mergeWithCss(headerItemStyles, {
        css: css`
            grid-column: 5 / 6;
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    }),
};

linesHeaderStyles.total = {
    ...mergeWithCss(headerItemStyles, {
        css: css`
            grid-column: 6 / 7;
            ${({ includeActions }: any) => {
                if (!includeActions) {
                    return css`
                        border-right: none;
                    `;
                }
            }}
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    }),
};
